import type { ActivityType } from '@/lib/types';

export interface ActivityTypeMeta {
  label: string;
  shortLabel: string;
  icon: string;
  badgeClass: string;
  dotClass: string;
}

export const activityTypeMeta: Record<ActivityType, ActivityTypeMeta> = {
  SOCIAL: {
    label: 'Sortir',
    shortLabel: 'Sortir',
    icon: 'ri-cup-line',
    badgeClass: 'bg-secondary-100 text-secondary-800',
    dotClass: 'bg-secondary-500',
  },
  SPORT: {
    label: 'Bouger',
    shortLabel: 'Bouger',
    icon: 'ri-run-line',
    badgeClass: 'bg-accent-100 text-accent-800',
    dotClass: 'bg-accent-500',
  },
  HELP_REQUEST: {
    label: "Besoin d'aide",
    shortLabel: "S'entraider",
    icon: 'ri-hand-heart-line',
    badgeClass: 'bg-primary-100 text-primary-800',
    dotClass: 'bg-primary-500',
  },
  HELP_OFFER: {
    label: "Proposition d'aide",
    shortLabel: "S'entraider",
    icon: 'ri-service-line',
    badgeClass: 'bg-accent-100 text-accent-800',
    dotClass: 'bg-accent-500',
  },
};

export function getInitials(name: string): string {
  return name
    .split(' ')
    .filter(Boolean)
    .map((p) => p[0])
    .slice(0, 2)
    .join('')
    .toUpperCase();
}

const avatarPalette = [
  'bg-primary-100 text-primary-700',
  'bg-accent-100 text-accent-700',
  'bg-secondary-100 text-secondary-800',
  'bg-background-200 text-foreground-600',
];

export function avatarClass(name: string): string {
  return avatarPalette[name.length % avatarPalette.length];
}